$card-padding: 16px;

:host {
  @include reset-host;
}

:host .article-slide {
  display: flex;
  flex-direction: column;
  gap: rem(16);
  align-items: flex-start;
  width: 100%;
  height: 100%; // useful for same-height slider slides
  min-height: rem(300);
  padding: $card-padding;

  color: $white;
  font: inherit;
  text-align: left;

  background: $color-pink;
  border: 0;
  border-radius: rem(8);

  cursor: pointer;

  @each $color-key, $color-value in $theme-colors {
    &.is-#{$color-key}-variant {
      background: map-get($color-value, default);
    }
  }
}

:host .content {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

:host .text-wrapper {
  flex: 1;

  .title {
    font-weight: $fw-semibold;
    font-size: rem(50);
    font-family: $ff-title;
    line-height: 1.1;
  }
}

:host .image-wrapper {
  display: flex;
  align-items: center;

  width: calc(#{rem(84)} + #{$card-padding});
  height: rem(150);

  margin-right: -$card-padding;

  @include mq('max', 'md') {
    display: none;
  }
}

:host .cta {
  display: flex;
  gap: rem(38);
  justify-content: space-between;

  font-weight: $fw-medium;

  font-size: $fs-lg;
  line-height: 1.4;

  @include mq('max', 'md') {
    font-size: $fs-base;
  }

  .icon {
    font-size: rem(35);
  }
}
